/*
 * @Author: likk
 * @Date: 2023-11-28 17:34:54
 * @LastEditTime: 2023-12-01 15:12:36
 * @LastEditors: likk
 * @Description: 
 */
export const h5 = {
  path: "/h5",
  name: "",
  redirect: "/h5/last-review/intro",
  component: () => import("@/views/Jgb/h5/Home"),
  children: [
    //终评专题
    {
      path: "/h5/last-review",
      name: "H5LastReview",
      redirect:"/h5/last-review/intro",
      component: () => import("@/views/Jgb/h5/lastReview/index"),
      meta: {
        title: "终评专题",
      },
      children:[
        {
          path: "/h5/last-review/intro",
          name: "H5LastReviewIntro",
          component: () => import("@/views/Jgb/h5/lastReview/intro"),
          meta: {
            title: "活动介绍",
          },
        },
        {
          path: "/h5/last-review/term",
          name: "H5LastReviewTerm",
          component: () => import("@/views/Jgb/h5/lastReview/term/index"),
          meta: {
            title: "终评团队",
          },
        },
        {
          path: "/h5/last-review/rank",
          name: "H5LastReviewRank",
          component: () => import("@/views/Jgb/h5/lastReview/rank/index"),
          meta: {
            title: "获奖榜单",
          },
        },
        {
          path: "/h5/last-review/xianchang",
          name: "H5LastReviewXianchang",
          component: () => import("@/views/Jgb/h5/lastReview/xianchang/index"),
          meta: {
            title: "直击现场",
          },
        },
        {
          path: "/h5/last-review/xianchang/video-detail",
          name: "H5LastReviewVideoDetail",
          component: () => import("@/views/Jgb/h5/lastReview/xianchang/videoDetail"),
          meta: {
            title: "视频详情",
          },
          
        }
        
      ]
    },
    // 颁奖现场报道专题
    {
      path: "/h5/award-ceremony",
      name: "H5AwardCeremony",
      redirect:"/h5/award-ceremony/report",
      component: () => import("@/views/Jgb/h5/awardCeremony/index"),
      meta: {
        title: "颁奖现场报道专题",
      },
      children:[
        {
          path: "/h5/award-ceremony/report",
          name: "H5AwardCeremonyReport",
          component: () => import("@/views/Jgb/h5/awardCeremony/report/list"),
          meta: {
            title: "活动报道",
          },
        },
        {
          path: "/h5/award-ceremony/report/detail",
          name: "H5AwardCeremonyReportDetail",
          component: () => import("@/views/Jgb/h5/awardCeremony/report/detail"),
          meta: {
            title: "活动报道详情",
          },
        },
        {
          path: "/h5/award-ceremony/fazhan-dahui",
          name: "H5AwardCeremonyFazhandahui",
          component: () => import("@/views/Jgb/h5/awardCeremony/fazhanDahui/index"),
          meta: {
            title: "发展大会",
          },
        },
        {
          path: "/h5/award-ceremony/banjiang",
          name: "H5AwardCeremonyBanjiang",
          component: () => import("@/views/Jgb/h5/awardCeremony/banjiang/index"),
          meta: {
            title: "颁奖盛典",
          },
        },
        {
          path: "/h5/award-ceremony/xianchang",
          name: "H5AwardCeremonyXianchang",
          component: () => import("@/views/Jgb/h5/awardCeremony/xianchang/index"),
          meta: {
            title: "精彩现场",
          },
        },
        {
          path: "/h5/award-ceremony/video-play",
          name: "H5AwardCeremonyVideoPlay",
          component: () => import("@/views/Jgb/h5/awardCeremony/videoPlay"),
          meta: {
            title: "视频详情",
          },
        },
      ],
    }
    
  ]
}
